"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.middlewarePipeline = void 0;

require("regenerator-runtime/runtime");

var _InvalidPipelinePayloads = require("../lib/Exceptions/InvalidPipelinePayloads");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var middlewarePipeline =
/*#__PURE__*/
function () {
  var _ref = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee(context, middlewares) {
    var redirected, redirect, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, middleware, _, middlewareContext;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (Array.isArray(middlewares)) {
              _context.next = 2;
              break;
            }

            throw new _InvalidPipelinePayloads.InvalidPipelinePayload();

          case 2:
            redirected = false;

            redirect = function redirect(arg) {
              if (arg === undefined) {
                return;
              }

              context.next(arg);
              redirected = true;
            };

            _iteratorNormalCompletion = true;
            _didIteratorError = false;
            _iteratorError = undefined;
            _context.prev = 7;
            _iterator = middlewares[Symbol.iterator]();

          case 9:
            if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
              _context.next = 19;
              break;
            }

            middleware = _step.value;
            _ = context.next, middlewareContext = _objectWithoutProperties(context, ["next"]);
            _context.next = 14;
            return middleware(_objectSpread({}, middlewareContext, {
              redirect: redirect
            }));

          case 14:
            if (!redirected) {
              _context.next = 16;
              break;
            }

            return _context.abrupt("break", 19);

          case 16:
            _iteratorNormalCompletion = true;
            _context.next = 9;
            break;

          case 19:
            _context.next = 25;
            break;

          case 21:
            _context.prev = 21;
            _context.t0 = _context["catch"](7);
            _didIteratorError = true;
            _iteratorError = _context.t0;

          case 25:
            _context.prev = 25;
            _context.prev = 26;

            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
              _iterator["return"]();
            }

          case 28:
            _context.prev = 28;

            if (!_didIteratorError) {
              _context.next = 31;
              break;
            }

            throw _iteratorError;

          case 31:
            return _context.finish(28);

          case 32:
            return _context.finish(25);

          case 33:
            if (!redirected) {
              context.next();
            }

          case 34:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[7, 21, 25, 33], [26,, 28, 32]]);
  }));

  return function middlewarePipeline(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

exports.middlewarePipeline = middlewarePipeline;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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